var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"block":"","elevation":"0"},on:{"click":function($event){return _vm.exportAll()}}},[_vm._v("Выгрузить все")]),_c('confirm-dialogue',{ref:"confirmDialogue"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }